import {AuthGroup, AuthRole, userHasRole, userHasGroupMembership} from "../framework/Authorization";
import {useEffect, useState} from "react";
import {getUserProfile} from "../framework/UserService";

const UserDetails = () => {

    const [user, setUser] = useState(null);

    useEffect(() => {
        getUserProfile().then((userProfile) => {
            setUser(userProfile);
        })
    }, [])


    return (
		
        <div className="userDetail">
			<h2>User Details</h2>
            <div className="userRoles">
                <AuthRole user={user} role="admin">
                    <div className="adminRole" data-testid="adminRoleId1">User has admin role</div>
                </AuthRole>
                <AuthRole user={user} role="user">
                    <div className="userRole" data-testid="userRoleId1">User has non-admin user role</div>
                </AuthRole>
            </div>

            <div className="userGroupMemberShipWebTeam" id="webTeamGroup1">
                <AuthGroup user={user} group="/WEB Team">
                    <div className="email">User has web team membership</div>
                </AuthGroup>
                <AuthGroup user={user} group="/Group test">
                    <div className="checkName">User has Group test membership</div>
                </AuthGroup>
            </div>

            <div className="userHasRole">
                {userHasRole(user, 'admin') ? <div className="userRoleAdmin">User has admin role</div> : ''}
                {userHasRole(user, 'user') ? <div className="userRoleUser">User has non-admin user role</div> : ''}
            </div>

            <div className="userHasGroupMembershipTest">
                {userHasGroupMembership(user, '/WEB Team') ?
                    <div className="userRoleAdmin">User has group WebTeam membership role</div> : ''}
                {userHasGroupMembership(user, '/Group test') ?
                    <div className="userRoleUser">User has group test membership</div> : ''}
            </div>

        </div>


    );
}

export default UserDetails;